import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';
import _ from 'lodash';
import { updateCartCountEventBus, UPDATE_CART_COUNT } from './../msw-checkout/constants/checkout-constants';
export interface CatalogStoreState {
  isFromHES: boolean;
  isReadOnlyAccess: boolean;
  serialNumber: string;
  isguestbuynow: boolean;
  mode: string;
  serviceTypes: any[];
  rootServiceId: string;
  cartCount: number;
  isguestaddedtocart: boolean;
  friendlyName: string;
  serviceId: string;
  ssipn: string;
}

export default {
  state: {
    isFromHES: false,
    isReadOnlyAccess: false,
    serialNumber: '',
    isguestbuynow: false,
    mode: 'default',
    serviceTypes: [],
    rootServiceId: '',
    cartCount: 0,
    isguestaddedtocart: false,
    friendlyName: '',
    serviceId: '',
    ssipn: '',
  },
  mutations: {
    mutate(state: any, payload: { property: any, with: any }) {
      state[payload.property] = payload.with;
    },
    updateServiceTypes(state: any, payload: { rootServiceId: any, property: any, with: any[] }) {
      if (payload.property === 'ALL') {
        state.serviceTypes = [...payload.with];
      } else {
        try {
          const temp: any[] = _.cloneDeep(state.serviceTypes);
          temp.map((tempElement: any) => {
            if (tempElement.serviceId === payload.rootServiceId) {
              tempElement[payload.property] = payload.with[0] ? payload.with[0] : '';
            }
          });
          state.serviceTypes = _.cloneDeep(temp);
        } catch (e) {
        }
      }
    },
  },
  actions: {
    getServiceList(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = '';
      if (payload.isguestbuynow) {
        endpoint = `order/get-service-list${window.location.search}`;
      } else {
        endpoint = `order/get-service-list?serviceId=${payload.serviceId}&productId=${payload.productName}&serialNumber=${payload.serialNumber}&ssipn=${payload.ssipn}&equoteid=${payload.equoteid}`;
      }
      return ApiServiceWrapper.get(endpoint);
    },
    getProductCatalog(context: ActionContext<CatalogStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'order/get-product-catalog';
      return ApiServiceWrapper.get(endpoint);
    },
    getServiceTypes(context: ActionContext<CatalogStoreState, RootStoreState>, productCategoryId: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/get-service-type?productCategoryId=${productCategoryId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getProjections(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = '';
      if (payload.isdynamicnodecount) {
        endpoint = `order/get-projections?rootServiceID=${payload.rootServiceID}&serialNumber=${payload.serialNumber}&serviceId=${payload.serviceId}&quantity=${payload.quantity}&nodecount=${payload.nodecount}`;
      } else {
        endpoint = `order/get-projections?rootServiceID=${payload.rootServiceID}&serialNumber=${payload.serialNumber}&serviceId=${payload.serviceId}&quantity=${payload.quantity}`;
      }
      return ApiServiceWrapper.get(endpoint);
    },
    updateServiceType(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      context.commit('updateServiceTypes', payload);
    },
    getProductGroup(context: ActionContext<CatalogStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/get-productgroup-details';
      return ApiServiceWrapper.get(endpoint);
    },
    addToCart(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'order/add-to-cart';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    // tslint:disable-next-line:no-unused
    changeCartCount(context: ActionContext<CatalogStoreState, RootStoreState>, newCount: any) {
      let cartCount: number = 0;
      if (newCount === undefined || newCount === null) {
        console.error('cart count is invalid');
        cartCount = 0;
      } else if (typeof newCount === 'string') {
        cartCount = parseInt(newCount, 10);
      } else {
        cartCount = newCount || 0;
      }
      context.commit('mutate', { property: 'cartCount', with: cartCount  });
      updateCartCountEventBus.$emit(UPDATE_CART_COUNT, newCount);
      if ((window as { [key: string]: any }).location.href !== (window as { [key: string]: any }).top.location.href) {
        window.parent.postMessage({ updateCartCount : `${cartCount}` }, '*');
      }
      try {
        localStorage.setItem('cartCount', `${cartCount}`);
      } catch (e) {
        console.error(e);
      }
    },
    // tslint:disable-next-line:no-unused
    getBasketDetails(context: ActionContext<CatalogStoreState, RootStoreState>, request: any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = `order/basket/get?basketId=${0}`;
      if (!_.isEmpty(request)) {
        endpoint = `${endpoint}&fromConfirmPage=${request}`;
      }
      return  ApiServiceWrapper.get(endpoint);
    },
    getServiceListForHES(context: ActionContext<CatalogStoreState, RootStoreState>, request: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/get-service-list?isFromHES=${request.isFromHES}&serviceId="${request.serviceId}&friendlyName=${request.friendlyName}&serialNumber=${request.serialNumber}&ssipn=${request.ssipn}`;
      return ApiServiceWrapper.get(endpoint);
    },
    checkHesPresence(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/checkhespresence?tenantid=${payload.tenantGroupID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCasAppilations(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = 'casb-application';
      if (!_.isEmpty(payload)) {
        if (payload.activationKey) {
          if (payload.ssipn) {
            endpoint = `${endpoint}?key=${payload.activationKey}&ssipn=${payload.ssipn}`;
          } else {
            endpoint = `${endpoint}?key=${payload.activationKey}`;
          }
        }
      }
      return ApiServiceWrapper.get(endpoint);
    },
    removeFromCart(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/basketitem/remove?basketitemid=${payload.basketItemId}`;
      return ApiServiceWrapper.delete(endpoint);
    },
    updateQuantityOfItemsInCart(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/basketitem/updateqty?basketitemid=${payload.basketitemid}&qty=${payload.qty}`;
      return ApiServiceWrapper.post(endpoint, {});
    },
    updateUserCount(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/basketitem/updateusercount?usercount=${payload.usercount}&basketitemid=${payload.basketitemid}`;
      return ApiServiceWrapper.post(endpoint, {});
    },
    updateAutoRenewal(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/basketitem/updaterenew?renew=${payload.renew}&basketitemid=${payload.basketitemid}`;
      return ApiServiceWrapper.post(endpoint, {});
    },
    saveQuote(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/${payload.basketid}/save-quote`;
      return ApiServiceWrapper.post(endpoint, {});
    },
    updateNodeCount(context: ActionContext<CatalogStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `order/basketitem/updatenodecount?nodecount=${payload.nodecount}&basketitemid=${payload.basketitemid}`;
      return ApiServiceWrapper.post(endpoint, {});
    },
  },
  getters: {
    getCustomOperationalMode: state => state.mode,
    getServiceTypes: state => state.serviceTypes,
    getCartCount: state => state.cartCount,
  },
  namespaced: true,
} as Module<CatalogStoreState, RootStoreState>;
